import { render, staticRenderFns } from "./FinalExamTeacherStudDetailView.vue?vue&type=template&id=4d816f79"
import script from "./FinalExamTeacherStudDetailView.vue?vue&type=script&lang=js"
export * from "./FinalExamTeacherStudDetailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports